<script lang="ts" setup>
import type GiftGreeting from '@consumer/types/GiftGreeting'
import type { GiftlyMetadata } from '@consumer/types/serializers'
import { useElementSize } from '@vueuse/core'
import newMiscStarsTogetherIcon from '@consumer/assets/icons/new-misc/stars-together.svg?svgicon'
import previewEnvelopeIcon from '@consumer/assets/icons/preview-envelope.svg?svgicon'
import previewYesShadowIcon from '@consumer/assets/icons/preview-yes-shadow.svg?svgicon'
import previewGiftlyShadowIcon from '@consumer/assets/icons/preview-giftly-shadow.svg?svgicon'

const { gift, showStars } = defineProps<{
  gift: {
    greeting: GiftGreeting
    giftlyVersion: number
    giftlyMetadata: GiftlyMetadata
  }
  showStars?: boolean
}>()

const giftCardImageUrl = computed(
  () => gift.greeting.card?.previewImageUrl ?? gift.greeting.card?.thumbnailImageUrl,
)

const color = computed(() => gift.giftlyMetadata?.themeColor || '#44A4FF')

const greetingCardLoaded = $ref(false)
const giftCardLoaded = $ref(false)

const previewEl = $ref<HTMLElement>()
const { width: containerWidth } = useElementSize(() => previewEl)
watch(
  containerWidth,
  (width) => {
    if (!previewEl) return

    // Set the font size to 1px as the basis when rendering at 475px, allowing
    // us to use em as if they were px.
    previewEl.style.fontSize = `${previewEl.offsetWidth / (showStars ? 475 : 350)}px`
  },
)
</script>

<template>
  <div
    ref="previewEl"
    class="flex flex-col justify-end items-center relative w-full"
  >
    <GIcon
      v-if="showStars"
      :svg="newMiscStarsTogetherIcon"
      class="absolute"
      size="70em"
      style="left: -8em; top: 28em;"
    />
    <GIcon
      v-if="showStars"
      :svg="newMiscStarsTogetherIcon"
      class="absolute transform -rotate-x-180"
      size="70em"
      style=" bottom: -3em;right: -8em;"
    />
    <div
      class="relative"
      style="height: 112em; margin-top: 118em; width: 168em;"
    >
      <GIcon
        :svg="previewEnvelopeIcon"
        class="absolute"
        :style="`
          bottom: 31em;
          left: -79em;
          color: ${color};
          width: 183em;
          height: 198em;
          stroke: none;
        `"
      />
      <div class="absolute" style="bottom: 22em; right: -73em;">
        <GIcon
          v-if="greetingCardLoaded"
          :svg="previewYesShadowIcon"
          class="absolute"
          style="bottom: -4em; height: 44em; right: -44em; width: 100%;"
        />
        <img
          class="greeting-card bg-no-repeat bg-white bg-cover relative shadow-v2md"
          :src="giftCardImageUrl"
          style="border-radius: 8em; height: 202em; width: 151.5em;"
          @load="greetingCardLoaded = true"
        >
      </div>
      <GIcon
        v-if="giftCardLoaded"
        :svg="previewGiftlyShadowIcon"
        class="absolute"
        style=" bottom: -4em;height: 42em; right: -42em; width: 100%;"
      />
      <GiftlyImage :gift="gift" @imageLoaded="giftCardLoaded = true"/>
    </div>
  </div>
</template>
